module.exports = {
	"de": {
		"titel": "Die Halle der Runen-Karten"
	},
	"en": {
		"titel": "Buy"
	}
};


//////////////////
// WEBPACK FOOTER
// ./lib/runeset-view/locales.json
// module id = 68
// module chunks = 0